module.exports = "/_next/static/images/OctoDiagram-lg@2x-14330f6951c8f5bac056af62368f1573.webp";